module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("完善个人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('form', {
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitHandler($event)
      }
    }
  }, [_c('div', {
    staticClass: "group-title"
  }, [_vm._v("实名信息")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group"
  }, [_c('div', {
    staticClass: "input-cells"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-cell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-cells"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-cell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idcard),
      expression: "idcard"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.idcard)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idcard = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "group-title"
  }, [_vm._v("收款信息")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group"
  }, [_c('div', {
    staticClass: "input-cells"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-cell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankNo),
      expression: "bankNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bankNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankNo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-cells"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-cell"
  }, [_c('div', {
    staticClass: "form-control",
    on: {
      "click": function($event) {
        _vm.pickerShow = true
      }
    }
  }, [_vm._v(_vm._s(_vm.bankName))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankCode),
      expression: "bankCode"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.bankCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankCode = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('picker', {
    attrs: {
      "data-items": _vm.bankList
    },
    on: {
      "change": _vm.onItemChange
    },
    model: {
      value: (_vm.pickerShow),
      callback: function($$v) {
        _vm.pickerShow = $$v
      },
      expression: "pickerShow"
    }
  }, [_c('div', {
    slot: "header"
  }, [_vm._v("请选择开户行")]), _vm._v(" "), _c('button', {
    staticClass: "btn-submit",
    on: {
      "click": function($event) {
        _vm.pickerShow = false
      }
    },
    slot: "footer"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('toast', {
    attrs: {
      "show": _vm.toastShow,
      "text": _vm.toastText
    },
    on: {
      "hidden": function($event) {
        _vm.toastShow = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-cell"
  }, [_c('label', [_vm._v("真实姓名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-cell"
  }, [_c('label', [_vm._v("身份证号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-cell"
  }, [_c('label', [_vm._v("银行卡号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-cell"
  }, [_c('label', [_vm._v("开户银行")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("保存")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea0a2458!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/profile-wjd.vue
// module id = 377
// module chunks = 1